import { Fragment } from 'react';

import { Button } from 'primereact/button';

import { TenantClientService as Service } from './TenantClientService';
import { MGateWayService } from '../../lich-su-truyen-nhan/MGateWayService';

import { ToastService } from '../../../AppToast';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';
import { useImExExcel } from '../../../shared/hooks/ImExExcel';
import { AppStorage } from '../../../service/UserStorage';
import { SearchCMNDService } from '../../../service/SearchCMND';
import { normalizeCustomerAddress } from '../../../shared/utils/customerAddress';
import { useTranslation } from '../../../shared/language';
export const List = () => {

  const {t} = useTranslation();
  const header = t('catalog.customer');
  const dataKey = 'id';

  const { render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams, items } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'code', header: t('common.customerCode'), width: 160, matchMode: 'contains' },
      { field: 'name', header: t('common.entityName'), minWidth: 220, matchMode: 'contains' },
      { field: 'taxCode', header: t('common.taxCode'), width: 160, matchMode: 'contains' },
      { field: 'personContact', header: t('common.buyerContact'), width: 160, matchMode: 'contains' },
      { field: 'buyerIdentityCard', header: t('common.identityCard'), width: 160, matchMode: 'contains' },
      { field: 'buyerBudgetUnitCode', header: t('common.budgetUnitCode'), width: 230, matchMode: 'contains' },
      { field: 'address', header: t('common.address'), minWidth: 160, matchMode: 'contains' },
      { field: 'mobile', header: t('common.phone'), width: 160, matchMode: 'contains' },
      { field: 'email', header: t('auth.email'), width: 160, matchMode: 'contains' },
      { field: 'bankAccount', header: t('catalog.accountNumber'), width: 160, matchMode: 'contains' },
      { field: 'bankName', header: t('system.bankName'), width: 160, matchMode: 'contains' },
      { field: 'hasAccount', header: t('common.customerAccountCreated'), width: 180, matchMode: 'equals', filterType: 'boolean', dataType: 'boolean' },
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const searchTaxCode = () => {
    const { taxCode, code } = getValue();

    const validateTaxCode = (value) => {
      let patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
      if (value.length > 10) {
        patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][-][0-9][0-9][0-9]$/;
      }
      const cccdRegex = /^[0-9]{3}[0-5]\d{2}\d{6}$/;
      if (value === "") return true;

      // Kiểm tra nếu là căn cước công dân (12 ký tự)
      if (value.length === 12) {
        return cccdRegex.test(value);
      }

      // Kiểm tra mã số thuế
      if (patt.test(value) === false) {
        return false;
      }
      const number = Number(value.charAt(0)) * 31 + Number(value.charAt(1)) * 29 + Number(value.charAt(2)) * 23
        + Number(value.charAt(3)) * 19 + Number(value.charAt(4)) * 17 + Number(value.charAt(5)) * 13
        + Number(value.charAt(6)) * 7 + Number(value.charAt(7)) * 5 + Number(value.charAt(8)) * 3;

      return (10 - number % 11) === Number(value.charAt(9));
    };

    const isValidTaxCode = validateTaxCode(taxCode);

    if (taxCode.length === 12 && isValidTaxCode) {
      SearchCMNDService.get(taxCode).then(data => {

        if (data) {
          if (data.error) {
            ToastService.error(data.error);
          } else if (data.ho_ten) {
            setValue({
              code: code || '',
              taxCode: taxCode || '',
              name: data.ho_ten || '',
            });
          } else {
            ToastService.error(t('common.searchCccdNotFound'));
          }
        } else {
          MGateWayService.searchTaxCodeV2(taxCode).then(data => {
            if (data) {
              setValue({
                code: code || '',
                taxCode: data.buyerTaxCode || '',
                name: data.buyerLegalName || '',
                personContact: data.buyerDisplayName || '',
                address: normalizeCustomerAddress(data.buyerAddress)
              });
            }
          }).catch(error => {
            ToastService.error(t('common.searchCccdError'));
          });
        }
      }).catch(error => {
        MGateWayService.searchTaxCodeV2(taxCode).then(v2Data => {
          if (v2Data) {
            setValue({
              code: code || '',
              taxCode: v2Data.buyerTaxCode || '',
              name: v2Data.buyerLegalName || '',
              personContact: v2Data.buyerDisplayName || '',
              address: normalizeCustomerAddress(v2Data.buyerAddress)
            });
          } else {
            ToastService.error(t('common.searchTaxDataNotFound'));
          }
        }).catch(v2Error => {
          ToastService.error(t('common.searchCccdError'));
        });
      });
    } else if (isValidTaxCode) {
      // Gọi searchTaxCode (V1) trước
      MGateWayService.searchTaxCode(taxCode).then(data => {
        if (data) {
          const provinceName = data.dctstinhten ?
            (data.dctstinhten.includes('TP') ? data.dctstinhten.replace('TP', 'Thành phố') : `Tỉnh ${data.dctstinhten}`) : '';

          setValue({
            code: code || '',
            taxCode: data.mst || '',
            name: data.tennnt || '',
            personContact: data.buyerDisplayName || '',
            address: normalizeCustomerAddress(`${data.dctsdchi}, ${data.dctsxaten}, ${provinceName}, Việt Nam`)
          });
        } else {
          // Nếu V1 không có dữ liệu, thử V2
          MGateWayService.searchTaxCodeV2(taxCode).then(v2Data => {
            if (v2Data) {
              setValue({
                code: code || '',
                taxCode: v2Data.buyerTaxCode || '',
                name: v2Data.buyerLegalName || '',
                personContact: v2Data.buyerDisplayName || '',
                address: normalizeCustomerAddress(v2Data.buyerAddress)
              });
            } else {
              ToastService.error(t('common.searchTaxDataNotFound'));
            }
          }).catch(v2Error => {
            ToastService.error(t('common.searchTaxDataV2Error'));
          });
        }
      }).catch(v1Error => {
        // Nếu V1 lỗi, thử V2
        MGateWayService.searchTaxCodeV2(taxCode).then(v2Data => {
          if (v2Data) {
            setValue({
              code: code || '',
              taxCode: v2Data.buyerTaxCode || '',
              name: v2Data.buyerLegalName || '',
              personContact: v2Data.buyerDisplayName || '',
              address: normalizeCustomerAddress(v2Data.buyerAddress)
            });
          } else {
            ToastService.error(t('common.searchTaxDataNotFound'));
          }
        }).catch(v2Error => {
          ToastService.error(t('common.searchTaxDataError'));
        });
      });
    }
  }

  const { render: renderDialogCrup, create, update, clone, getValue, setValue } = useDialogCrup({
    header,
    dataKey,
    width: '60rem',
    fields: [
      { field: 'code', header: t('common.customerCode'), required: true, uppercase: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'taxCode', header: t('common.taxCode'), InputTextProps: { maxLength: 14, validator: 'taxCode' }, className: 'md:col-5' },
      {
        type: 'custom', className: 'md:col-1', body: (
          <div className="mt-4">
            <Button icon="pi pi-search" className="p-button-rounded p-button-outlined" onClick={searchTaxCode} />
          </div>
        )
      },
      { field: 'name', header: t('common.entityName'), InputTextProps: { maxLength: 400 }, className: 'md:col-12' },
      { field: 'personContact', header: t('common.buyerContact'), InputTextProps: { maxLength: 100 }, className: 'md:col-4' },
      { field: 'buyerIdentityCard', header: t('common.identityCard'), InputTextProps: { maxLength: 12 }, className: 'md:col-4' },
      { field: 'buyerBudgetUnitCode', header: t('common.budgetUnitCode'), InputTextProps: { maxLength: 7 }, className: 'md:col-4' },
      { field: 'address', header: t('common.address'), InputTextProps: { maxLength: 400 }, className: 'md:col-12' },
      { field: 'email', header: t('auth.email'), InputTextProps: { maxLength: 250, placeholder: t('common.emailSeparatorPlaceholder') }, className: 'md:col-6' },
      { field: 'mobile', header: t('common.phone'), InputTextProps: { maxLength: 20 }, className: 'md:col-6' },
      { field: 'bankAccount', header: t('catalog.accountNumber'), InputTextProps: { maxLength: 30 }, className: 'md:col-5' },
      { field: 'bankName', header: t('system.bankName'), InputTextProps: { maxLength: 400 }, className: 'md:col-7' }
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const { render: renderDialogCrupUser, update: crupUser } = useDialogCrup({
    header: t('common.lookupAccount'),
    dataKey,
    width: '45rem',
    fields: [
      { field: 'name', header: t('common.customerName'), disabled: true, className: 'md:col-12' },
      { field: 'taxCode', header: t('common.taxCode'), disabled: true, className: 'md:col-12' },
      { field: 'code', header: t('common.customerCode'), disabled: true, className: 'md:col-12' },
      { field: 'userName', header: t('auth.username'), className: 'md:col-12' },
      { field: 'password', header: t('auth.password'), type: "Password", InputTextProps: { maxLength: 400 }, className: 'md:col-12' },
      { field: 'email', header: t('auth.email'), InputTextProps: { maxLength: 400 }, className: 'md:col-12' }
    ],
    updateItem: (id, item) => {

      if (item.hasAccount === true) {
        ToastService.error(t('validation.selectCustomer'));
        return;
      }
      let accountInfo = {
        id,
        taxCode: AppStorage.get('tenantName'),
        customerCode: item.code,
        userName: item.userName,
        password: item.password,
        email: item.email,
        appVersion: 2,
      };
      return Service.createAcccountSearch(accountInfo);
    },
    refreshLazyData
  });

  const { renderImExExcel, download, showImportDialog } = useImExExcel({
    exportTemplate: () => {
      return Service.downloadExcelTemplate();
    },
    exportExcel: (params) => {
      return Service.downloadExcel(params);
    },
    exportExcelFileName: 'danh-muc-khach-hang',
    importExcel: (data) => {
      return Service.uploadExcel(data);
    },
    reloadLazyData
  });

  const showCrupUser = () => {
    if (selectedItems?.['id']) {
      crupUser(selectedItems);
    } else {
      ToastService.error(t('validation.selectCustomer'));
    }
  }

  const { renderToolbar } = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    showImportDialog,
    exportExcel: download, dataTableParams,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    otherActions: [
      {
        label: t('common.createLookupUser'), icon: 'pi pi-fw pi-user', className: 'iam-toolbar iam-toolbar-help', command: showCrupUser
      }
    ]
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
      {renderDialogCrupUser()}
      {renderImExExcel()}
    </Fragment>
  )
}
